import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { serviceRoles } from '../../utils/serviceRoles';
import { serviceLocalStorage } from '../../utils/serviceLocalStorage';

export const PublicRoute = ({ component: Component, ...rest }) => {
  const { isAuth } = useSelector((state) => state.currentUser);

  return (
    <Route
      {...rest}
      render={(props) =>
        !isAuth && !serviceLocalStorage.getAccessToken() ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{ pathname: serviceRoles(+serviceLocalStorage.getUserRoleID()).firstPage }}
          />
        )
      }
    />
  );
};

PublicRoute.propTypes = {
  component: PropTypes.any
};
